import React from 'react';
import { returnReadableDate } from '../datetime';
import { returnCustomerAddressString } from '../table';
import { formatToINR, schemeTypeMap } from './constantsAndUtils';

export const individualSchemeTable = (type, sellIntype) => {
  const currentType = type === schemeTypeMap.foc ? sellIntype : type;
  switch (currentType) {
    case schemeTypeMap.sellIn:
      return [
        {
          dataField: 'Branch',
          sort: true,
          text: 'Branch',
        },
        {
          dataField: 'PurchaseDate',
          sort: true,
          text: 'Purchase Date',
          formatter: (cell, row) => {
            return returnReadableDate(cell);
          },
        },
        {
          dataField: 'Product',
          text: 'Product',
          formatter: (cell, row) => {
            return returnCustomerAddressString(cell, null, 200, 30, 'top');
          },
        },
        {
          dataField: 'PurchaseVNo',
          text: 'Voucher No.',
        },
        {
          dataField: 'TotalQuantity',
          text: 'Quantity',
        },
        {
          dataField: 'TotalAmount',
          text: 'Amount',
          formatter: formatToINR,
        },
        {
          dataField: 'TotalSGST',
          text: 'SGST',
          formatter: formatToINR,
        },
        {
          dataField: 'TotalCGST',
          text: 'CGST',
          formatter: formatToINR,
        },
        {
          dataField: 'TotalIGST',
          text: 'IGST',
          formatter: formatToINR,
        },
        {
          dataField: 'TotalGSTAmount',
          text: 'GST Amount',
          formatter: formatToINR,
        },
      ];
    case schemeTypeMap.priceDrop:
      return [
        {
          dataField: 'vanNo',
          text: 'VanNo',
        },
        {
          dataField: 'product',
          text: 'ProductName',
          formatter: (cell, row) => {
            return returnCustomerAddressString(cell, null, 200, 30, 'top');
          },
        },
        {
          dataField: 'storeName',
          text: 'Branch',
        },
        {
          dataField: 'totalStock',
          text: 'totalStock',
        },
      ];
    default:
      return [
        {
          dataField: 'orderDate',
          sort: true,
          text: 'Order Date',
          formatter: (cell, row) => {
            return returnReadableDate(cell);
          },
        },
        {
          dataField: 'branch',
          text: 'Branch',
        },
        {
          dataField: 'product',
          text: 'Product',
          formatter: (cell, row) => {
            return returnCustomerAddressString(cell, null, 200, 30, 'top');
          },
        },
        {
          dataField: 'serialNo',
          text: 'Serial No',
        },
        {
          dataField: 'invoiceNo',
          text: 'Invoice No',
          formatter: (cell, row) => {
            return <div>{cell || row?.returnVoucherNo || '-'}</div>;
          },
        },
        {
          dataField: 'orderNo',
          text: 'Order No',
        },
        {
          dataField: 'vanNo',
          text: 'VanNo',
        },
        {
          dataField: 'quantity',
          text: 'Quantity',
        },
        {
          dataField: 'amount',
          text: 'Amount',
          formatter: formatToINR,
        },
        {
          dataField: 'SGST',
          text: 'SGST',
          formatter: formatToINR,
        },
        {
          dataField: 'CGST',
          text: 'CGST',
          formatter: formatToINR,
        },
        {
          dataField: 'IGST',
          text: 'IGST',
          formatter: formatToINR,
        },
      ];
  }
};

export const sellOutTable = () => {
  return [
    {
      dataField: 'product',
      text: 'Product',
      formatter: (cell, row) => {
        return returnCustomerAddressString(cell, null, 300, 30, 'top');
      },
    },
    {
      dataField: 'vanNo',
      text: 'VanNo',
      formatter: (cell, row) => {
        if (Array.isArray(cell)) {
          return (
            <>
              {cell.map((item, index) => (
                <div key={index}>{item}</div>
              ))}
            </>
          );
        }
        return <>{cell}</>;
      },
    },
    {
      dataField: 'payout',
      text: 'Payout',
      formatter: formatToINR,
    },
    {
      dataField: 'valuationType',
      text: 'Valuation',
    },
    {
      dataField: 'currentQuantity',
      text: 'Current Quantity',
    },
    {
      dataField: 'currentValue',
      text: 'Current Value',
      formatter: formatToINR,
    },
    {
      dataField: 'totalPositiveQuantity',
      text: 'Sold/Purchase Quantity',
    },
    {
      dataField: 'totalNegativeQuantity',
      text: 'Return Qty',
    },
    {
      dataField: 'totalOpenQuantity',
      text: 'Open Qty',
    },
    {
      dataField: 'cappingType',
      text: 'Capping Type',
    },
    {
      dataField: 'cappingQuantity',
      text: 'Capping Qty',
    },
    ,
  ];
};

export const getSchemeDetailTable = (schemeType, focType) => {
  let result = sellOutTable();
  switch (schemeType) {
    case 'Sell-in':
      result = sellOutTable().slice(0, 8);
      result.push({
        dataField: 'target',
        text: 'Target',
      });
      break;
    case 'Upgrade-offer':
      result = sellOutTable().slice(0, 9);
      result.push(
        {
          dataField: 'totalVsAmount',
          text: 'VS Amount',
          formatter: formatToINR,
        },
        {
          dataField: 'totalBrandAmount',
          text: 'Brand Amount',
          formatter: formatToINR,
        }
      );
      break;
    case schemeTypeMap.foc:
      // switch (focType) {
      //   case 'Many-One':
      //   case 'Many-Many':
      //   case 'One-One':
      //   case 'One-Many':
      result = sellOutTable().slice(1, 2);
      result.push(
        {
          dataField: 'freebieVan',
          text: 'Freebie Van',
          formatter: (cell, row) => {
            return (
              <>
                {cell?.map((item) => (
                  <div>{item}</div>
                ))}
              </>
            );
          },
        },
        {
          dataField: 'targetQuantity',
          text: 'Quantity',
        },

        {
          dataField: 'freebieQuantity',
          text: 'Freebie Quantity',
        },
        {
          dataField: 'slabs',
          text: 'Slab',
          formatter: (cell, row) => {
            return (
              <>
                {cell
                  ? Object.keys(cell)?.map((item) => <div>{item || '-'}</div>)
                  : '-'}
              </>
            );
          },
        },
        {
          dataField: 'slabs',
          text: 'Slab Quantity',
          formatter: (cell, row) => {
            return (
              <>
                {cell
                  ? Object.values(cell)?.map((item) => <div>{item}</div>)
                  : '-'}
              </>
            );
          },
        },
        {
          dataField: 'totalQuantity',
          text: 'Total Quantity',
        },
        {
          dataField: 'totalFreebies',
          text: 'Total Freebies',
        },
        {
          dataField: 'totalPositiveQuantity',
          text: 'Sold/Purchase Quantity',
        },
        {
          dataField: 'totalNegativeQuantity',
          text: 'Return Qty',
        },
        {
          dataField: 'totalOpenQuantity',
          text: 'Open Qty',
        },
        {
          dataField: 'cappingQuantity',
          text: 'Capping',
        }
      );
      break;
    // }
    default:
      break;
  }
  return result;
};
